export const OPEN_COOKIE_SETTINGS = "openCookieSettings";
export const OPEN_PRIVACY_POLICY = "openPrivacyPolicy";
export const OPEN_COOKIES_POLICY = "openCookiesPolicy";

export function openCookieSettings() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS));
}

export function openPrivacyPolicy() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_PRIVACY_POLICY));
}

export function openCookiesPolicy() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(OPEN_COOKIES_POLICY));
}

// Zapis do localStorage
export const saveConsentToLocalStorage = consent => {
  localStorage.setItem("cookie-consent", JSON.stringify(consent));
};

// Pobranie z localStorage
export const getConsentFromLocalStorage = () => {
  const data = localStorage.getItem("cookie-consent");
  return data ? JSON.parse(data) : null;
};

// Ustawienie prawdziwego cookie
export const setBrowserCookie = (name, value) => {
  document.cookie = `${name}=${value}; path=/; max-age=31536000; SameSite=Lax`;
};

// Ustawienie wszystkich cookies na podstawie preferencji
export const applyCookieSettings = consent => {
  setBrowserCookie("necessary", consent.necessary);
  setBrowserCookie("analytics", consent.analytics);
  setBrowserCookie("marketing", consent.marketing);
};
